import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type {
  ApiError,
  ElasticsearchIndexRequest,
  ElasticsearchIndexResponse,
  ElasticsearchSearchRequest,
  ElasticsearchSearchResponse,
  ElasticsearchStatusResponse,
} from '../types/showcase';

/**
 * GET /api/eraf/showcase/demo/elasticsearch/status — C053 상태 조회
 * queryKey: ['common-showcase', 'elasticsearch', 'status']
 */
export function useElasticsearchStatus() {
  return useQuery<ElasticsearchStatusResponse, ApiError>({
    queryKey: ['common-showcase', 'elasticsearch', 'status'],
    queryFn: () => showcaseApi.elasticsearchStatus(),
    staleTime: 15_000,
  });
}

/**
 * POST /api/eraf/showcase/demo/elasticsearch/index — 문서 색인
 * 성공 시 status 캐시 무효화 (docCount 등 갱신)
 */
export function useElasticsearchIndex() {
  const queryClient = useQueryClient();
  return useMutation<ElasticsearchIndexResponse, ApiError, ElasticsearchIndexRequest>({
    mutationFn: (req) => showcaseApi.elasticsearchIndex(req),
    mutationKey: ['common-showcase', 'elasticsearch', 'index'],
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['common-showcase', 'elasticsearch', 'status'] });
    },
  });
}

/**
 * POST /api/eraf/showcase/demo/elasticsearch/search — 전문 검색
 * 색인 직후 자동 1회 호출 + 검색 폼 수동 제출 양쪽에서 재사용
 */
export function useElasticsearchSearch() {
  return useMutation<ElasticsearchSearchResponse, ApiError, ElasticsearchSearchRequest>({
    mutationFn: (req) => showcaseApi.elasticsearchSearch(req),
    mutationKey: ['common-showcase', 'elasticsearch', 'search'],
  });
}
